import React from 'react';
import Tooltip from '@components/dataDisplay/Tooltip';
import {
  AccessTooltipMsgMap,
  ACCESS_TYPE,
  ACCESS_TYPE_VALUE,
} from '@typings/common/accessType';
import Icon from '@components/dataDisplay/Icons/Icon';
import { TOOLTIP_DIR_TYPE_VALUE } from '@typings/common/tooltipDirType';

type Props = {
  accessType: ACCESS_TYPE_VALUE;
  direction?: TOOLTIP_DIR_TYPE_VALUE;
  style?: any;
};
function LockIcon({ accessType, direction = 'top', style }: Props) {
  if (!accessType) return null;
  return (
    <>
      {accessType !== ACCESS_TYPE.PUBLIC && (
        <Tooltip
          direction={direction}
          message={AccessTooltipMsgMap[accessType]}
        >
          <Icon name="Lock14" color={'var(--subTextColor)'} style={style} />
        </Tooltip>
      )}
    </>
  );
}

export default LockIcon;
